import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { OrganizationsService } from 'src/app/modules/organization/services/organizations.service'
import { environment } from 'src/environments/environment'
import { SharedService } from 'src/app/shared/services/shared.service'
import { ActivatedRoute, Router } from '@angular/router'
import { WalletStatus } from '../../models/wallet.enum'
import {
	spWalletList,
	spWalletAmount,
	adminWalletTotalPayload,
	adminWalletTotalResponse,
	clientWalletListFilter,
	clientWalletList,
	spWalletListPayload,
} from '../../models/wallet.models'
import { WalletService } from '../../services/wallet.service'
@Component({
	selector: 'app-wallet-list',
	templateUrl: './wallet-list.component.html',
	styleUrls: ['./wallet-list.component.scss'],
})
export class WalletListComponent implements OnInit {
	subscription = new Subscription()
	clientWalletList!: clientWalletList[]
	adminWalletTotal: adminWalletTotalResponse = {
		totalAmount: 0,
		totalHoldedAmount: 0,
		currency: {
			id: 0,
			name: {
				en: '',
				ar: '',
			},
		},
	}
	walletFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
		countryId: null,
	}

	spWallets: spWalletList[] = []
	filterCount = 0
	walletStatus = WalletStatus
	totalCount = 0
	totalCountClient = 0

	activeCountries!: any
	attachmentUrl = environment.attachmentPath
	breadCrumbRout: any
	queryParamObj: any = {}

	constructor(
		private SharedService: SharedService,
		public ActivatedRoute: ActivatedRoute,
		public translate: TranslateService,
		private organizationServ: OrganizationsService,
		private router: Router,
		private walletService: WalletService
	) {
		this.SharedService.headerTitle.next(`WALLET.WALLET_LIST.PAGE_TITLE`)
	}

	ngOnInit(): void {
		this.getActiveCountries()
		this.subscription.add(
			this.ActivatedRoute.queryParams.subscribe((res) => {
				this.walletFilter.countryId = res['country'] || 224
				this.walletFilter.activeTab = res['activeTab'] || 0
				this.walletFilter.paging.pageNumber = res['page'] || 1
				this.walletFilter.paging.pageSize = res['count'] || 10
				this.getTotalBalanceWalletList()
				this.SharedService.handleBreadCrumb('wallet', true, {
					name: '',
					id: '',
					url: '/layout/wallet',
					queryParams: { ...res },
				})

				res['activeTab'] == 1
					? this.getClientWalletList()
					: this.getSpWalletList()
			})
		)
	}
	getSpWalletList(search = false, filter: any = null) {
		search ? (this.walletFilter.paging.pageNumber = 1) : null
		filter ? (this.walletFilter = { ...this.walletFilter, ...filter }) : null
		this.subscription.add(
			this.walletService
				.getSpWalletList(this.walletFilter)
				.subscribe((res: any) => {
					this.spWallets = res.result.items
					this.totalCount = res.result.totalCount
				})
		)
	}
	getTotalBalanceWalletList() {
		let body = {
			countryId: this.walletFilter.countryId,
			actor:
				this.walletFilter.activeTab == 0
					? 2
					: this.walletFilter.activeTab == 1
					? 1
					: '',
		}
		this.subscription.add(
			this.walletService
				.getTotalBalanceWalletList(body)
				.subscribe((res: any) => {
					this.adminWalletTotal = res.result
				})
		)
	}
	getActiveCountries() {
		this.subscription.add(
			this.organizationServ.getActiveCountries().subscribe((res: any) => {
				this.activeCountries = res
			})
		)
	}

	getClientWalletList(search = false) {
		search ? (this.walletFilter.paging.pageNumber = 1) : null

		let body = {
			paging: {
				pageNumber: this.walletFilter.paging.pageNumber,
				pageSize: this.walletFilter.paging.pageSize,
			},
			searchText: this.walletFilter.searchText,
			countryId: this.walletFilter.countryId,
		}
		this.subscription.add(
			this.walletService.getClientWalletList(body).subscribe((res: any) => {
				this.clientWalletList = res.result.items
				this.totalCountClient = res.result.totalCount
			})
		)
	}

	tapChanged(event: any) {
		this.router.navigate(['/layout/wallet'], {
			queryParams: {
				country: this.walletFilter.countryId,
				activeTab: event,
			},
		})
	}
	pageChanged(pageNumber: number, pagecount: number) {
		this.router.navigate(['/layout/wallet'], {
			queryParams: {
				country: this.walletFilter.countryId,
				activeTab: this.walletFilter.activeTab,
				page: pageNumber,
				count: pagecount,
			},
		})
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
